import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  defaultValueInputLabel: {
    id: 'field-settings-menus.default-value-input.label.non-final',
    defaultMessage: 'Default value',
    description: 'Label for the input used to set a default value for a field.'
  },
  defaultValueInputHelper: {
    id: 'field-settings-menus.default-value-input.helper.non-final',
    defaultMessage: 'Value will be applied to new entries',
    description:
      'Helper text shown below a field default value input after a value is entered.'
  },
  defaultValueInputPlaceholder: {
    id: 'field-settings-menus.default-value-input.placeholder.non-final',
    defaultMessage: 'Add a default value',
    description: 'Placeholder text for a default value input when no value is set.'
  },
  allowMultiToggleSectionLabel: {
    id: 'field-settings-menus.allow-multi-toggle.section-label',
    defaultMessage: 'Limit',
    description: 'Section label for settings that limit field values.'
  },
  allowMultiToggleLabelTags: {
    id: 'field-settings-menus.allow-multi-toggle-tags.label',
    defaultMessage: 'Allow multiple tags',
    description: 'Label for the toggle that enables multiple tags for a tag/select field.'
  },
  allowMultiToggleLabelUsers: {
    id: 'field-settings-menus.allow-multi-toggle-users.label',
    defaultMessage: 'Allow multiple users',
    description: 'Label for the toggle that enables multiple users for a user field.'
  },
  allowMultiToggleLabelLinks: {
    id: 'field-settings-menus.allow-multi-toggle-links.label',
    defaultMessage: 'Allow multiple links',
    description:
      'Label for the toggle that enables multiple links for a Confluence, Jira, or Entry link field.'
  },
  allowMultiToggleTooltipTags: {
    id: 'field-settings-menus.allow-multi-toggle-tags.tooltip',
    defaultMessage:
      'Enabling multiple tags disables grouping by this field. This may remove grouping in views that use this field.',
    description:
      'Tooltip explaining that enabling multiple tags disables grouping by that field.'
  },
  allowMultiToggleTooltipUsers: {
    id: 'field-settings-menus.allow-multi-toggle-users.tooltip',
    defaultMessage:
      'Enabling multiple users disables grouping by this field. This may remove grouping in views that use this field.',
    description:
      'Tooltip explaining that enabling multiple users disables grouping by that field.'
  }
});
